import React from 'react';
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Plus, CheckCircle } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useOrgs from './hooks/useOrgs';
import useUserOrg from '@/src/Authentication/components/hooks/useUserOrg';
import { Button } from '@/src/shadComponents/ui/button';
import { Badge } from '@/src/shadComponents/ui/badge';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from '@/src/shadComponents/ui/table';

export default function OrgsTable() {
    const navigate = useNavigate();

    const { listOrgs } = useOrgs();
    const [orgs, setOrgs] = useState<Org[]>([]);
    const [isMounted, setIsMounted] = useState(true);
    const { orgId } = useUserOrg();

    useEffect(() => {
        setIsMounted(true);
        const fetchOrgs = async () => {
            const orgs = await listOrgs();
            isMounted && setOrgs(orgs);
        };
        fetchOrgs();

        return () => {
            setIsMounted(false);
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <div className="flex items-center justify-between px-4 sm:px-8 py-2 border-b border-border bg-muted/50">
                <span className="font-semibold text-sm text-foreground">Organizations</span>
                <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => navigate('create')}
                >
                    <Plus className="size-4" />
                </Button>
            </div>
            <Table>
                <TableHeader className="sr-only">
                    <TableRow>
                        <TableHead>Organization Name</TableHead>
                        <TableHead>More details</TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {orgs.map((org) => (
                        <TableRow key={org.id}>
                            <TableCell>
                                <div className="flex items-center gap-x-3">
                                    <span className="text-sm font-medium leading-6 text-foreground">
                                        {org.name}
                                    </span>
                                    {org.id === orgId && (
                                        <Badge variant="secondary">
                                            <CheckCircle className="size-3 mr-1" />
                                            Current
                                        </Badge>
                                    )}
                                </div>
                                {org.logo && (
                                    <div className="mt-1 text-xs leading-5 text-muted-foreground">
                                        {org.logo}
                                    </div>
                                )}
                            </TableCell>
                            <TableCell className="text-right">
                                <Button
                                    variant="link"
                                    onClick={() => navigate(`${org.id}`)}
                                >
                                    Administer Org
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    );
}
